import { useAuth } from '@/store/auth';
import { AccessPermission, ResourceAction } from '@/types/auth';

export function useHasAccess(action: ResourceAction) {
  const { user } = useAuth();

  if (!user) return false;

  // A role Connect doesn't know (Xano allows an empty one) gets no permissions instead of crashing.
  return AccessPermission[user.role]?.includes(action) ?? false;
}
